import { isEqual } from 'lodash';
import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import { IMatchingPos } from 'src/types/MatchingPos';
import axiosInstance from 'src/utils/axios';
import { removeTime } from 'src/utils/formatTime';

interface MatchPoRequest {
  poNumber: string;
  companyId: string;
}

const useGetPoMatchesApi = () => {
  const call = useCallback(
    (params?: MatchPoRequest) =>
      new Promise<IMatchingPos[]>(async (resolve, reject) => {
        try {
          const response = await axiosInstance.get<IMatchingPos[]>(
            api.getPoMatches(params?.poNumber as string, params?.companyId as string)
          );
          const data = response.data.map((po) => ({
            ...po,
            statusDate: removeTime(new Date(po.statusDate)),
            hasPoAccess:
              isEqual(String(params?.companyId), String(po.companyId)) &&
              [3, 11].includes(po.bStatus) &&
              [3, 10].includes(po.sStatus),
          }));
          resolve(data as IMatchingPos[]);
        } catch (error) {
          reject(error);
        }
      }),
    []
  );

  const { execute, isLoading } = useAsync(call, false);
  return { getPoMatches: execute, poMatchesLoading: isLoading };
};

export default useGetPoMatchesApi;
